// Меню шапки: до 1280px открывается по кнопке
export class HeaderMenu {
	constructor() {
		this.toggler = document.querySelector('.header__toggler')
		this.nav = document.querySelector('.header__nav')
		if (!this.toggler || !this.nav) return

		this.toggler.addEventListener('click', () => this.toggle(!this.nav.classList.contains('active')))

		this.nav.querySelectorAll('.header__nav-link').forEach((link) => {
			link.addEventListener('click', () => this.toggle(false))
		})

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && this.nav.classList.contains('active')) this.toggle(false)
		})

		window.matchMedia('(min-width: 1280px)').addEventListener('change', (e) => {
			if (e.matches && this.nav.classList.contains('active')) this.toggle(false)
		})
	}

	toggle(open) {
		this.toggler.classList.toggle('active', open)
		this.nav.classList.toggle('active', open)
		this.toggler.setAttribute('aria-expanded', open)
		document.body.classList.toggle('no-scroll', open)
	}
}
